import { listItemClasses } from '@mui/material/ListItem';
export var createMuiListItemOverrides = function (_a) {
    var _b;
    var tokens = _a.tokens, spacing = _a.spacing;
    return {
        styleOverrides: {
            root: (_b = {
                    paddingTop: spacing(1.25),
                    paddingBottom: spacing(1.25),
                    borderTop: "1px solid ".concat(tokens.color_border_default),
                    '&:last-child': {
                        borderBottom: "1px solid ".concat(tokens.color_border_default),
                    }
                },
                _b["&.".concat(listItemClasses.selected)] = {
                    backgroundColor: tokens.color_bg_selected_subtle,
                    color: tokens.color_fg_selected,
                },
                _b),
            button: {
                '&:hover': {
                    backgroundColor: tokens.color_bg_interactive_hover,
                },
            },
        },
    };
};
